<script lang="ts" setup>
import { FieldWrapper } from '@progress/kendo-vue-form';
import { Input as KInput } from '@progress/kendo-vue-inputs';
import {
  computed, onMounted, Ref, ref, watch, onUnmounted,
} from 'vue';

import Label from '@/components/Label.vue';
import Modal from '@/components/Modal.vue';
import Form from '@/components/form-controls/Form.vue';
import { t } from '@/locales';
import { useStore as ProQaUseStore } from '@/stores/ProQaStore';

const proQaStore = ProQaUseStore();
interface Props {
  dataTestid?: string,
  editMode?: boolean,
  workstation: string,
}
const localProps = withDefaults(defineProps<Props>(), {
  dataTestid: 'workstation_modal',
  editMode: false,
  workstation: '',
});

const emit = defineEmits(['dismiss']);
const workstation = ref(localProps.workstation);

// Action Buttons
const dismiss = () => {
  emit('dismiss');
};

const saveWorkstation = async () => {
  proQaStore.updateWorkstation(workstation.value);
  proQaStore.getProQaStatus();
  dismiss();
};

const formActionButtons = computed(() => [
  {
    dataTestid: `${localProps.dataTestid}_save_workstation`,
    mode: 'primary',
    label: t('general.actions.save'),
    type: 'submit',
    action: saveWorkstation,
    class: 'js--submit',
    themeColor: 'primary',
  },
  {
    dataTestid: `${localProps.dataTestid}_cancel`,
    label: t('general.actions.cancel'),
    type: 'cancel',
    action: dismiss,
    class: 'js--cancel ml-3',
    themeColor: 'tertiary',
  },
]);
</script>
<template>
  <Modal
    :data-testid="`${localProps.dataTestid}_modal`"
    :title="editMode ? t('callTaking.proqa.workstation.editTitle') : t('callTaking.proqa.workstation.addTitle')"
    :width="520"
    @close="dismiss"
  >
    <Form
      :data-testid="`${localProps.dataTestid}_form`"
      :action-buttons="formActionButtons"
    >
      <div class="flex align-items-start gap-2">
        <span
          class="ml-2 fas fa-3x fa-info-circle text-info"
          :data-testid="`${dataTestid}_info_icon`"
        />
        <FieldWrapper class="mx-5">
          <Label
            for="activate-resource-unit"
            :data-testid="`${localProps.dataTestid}_unit`"
            :label="t('callTaking.proqa.workstation.label')"
            class="font-medium"
          />
          <KInput
            v-model="workstation"
            id="workstation"
            :placeholder="t('callTaking.proqa.workstation.placeholder')"
            :data-testid="`${localProps.dataTestid}_workstation`"
            class="w-8"
          />
          <div
            class="mt-3"
            v-html="t('callTaking.proqa.workstation.info')"
          />
        </FieldWrapper>
      </div>
    </Form>
  </Modal>
</template>
